// 商品池統一定義（2026-05-19 從 4 → 8 個，對應後端 commit 3df3001）
//
// XM broker 顯示為 GOLD_ / SILVER_ 但前端/API/DB 通通用 XAUUSD/XAGUSD
// EXE 端 broker adapter 已處理 SYMBOL_ALIASES。
//
// 風險區間（MDD low/mid/high）依後端規則 — 前端不直接渲染，給 admin 提示用：
//   貴金屬 (XAUUSD/XAGUSD)：20/35/55
//   FX 一般：             15/25/40
//   GBPUSD：              18/30/45
//   AUDUSD：              16/28/42

export const SYMBOLS = [
  { code: 'XAUUSD', label: '黃金 (XAUUSD)',     short: '黃金',     category: 'metal' },
  { code: 'XAGUSD', label: '白銀 (XAGUSD)',     short: '白銀',     category: 'metal' },
  { code: 'EURUSD', label: '歐元/美元 (EURUSD)', short: '歐元/美元', category: 'fx' },
  { code: 'GBPUSD', label: '英鎊/美元 (GBPUSD)', short: '英鎊/美元', category: 'fx' },
  { code: 'USDJPY', label: '美元/日圓 (USDJPY)', short: '美元/日圓', category: 'fx' },
  { code: 'USDCAD', label: '美元/加幣 (USDCAD)', short: '美元/加幣', category: 'fx' },
  { code: 'USDCHF', label: '美元/瑞郎 (USDCHF)', short: '美元/瑞郎', category: 'fx' },
  { code: 'AUDUSD', label: '澳幣/美元 (AUDUSD)', short: '澳幣/美元', category: 'fx' },
];

// ── 策略工廠專用商品池（2026-08-06 擴充）─────────────────────────
//  ⚠️ 刻意**不併進上面的 SYMBOLS**：那份會被 BeastForm（使用者自行產生策略）用來渲染
//     下拉選單，而 Beast 那條路徑的 pip_size/contract_size 仍是寫死的四類（FX/金/銀），
//     使用者若選到指數/加密會拿到錯誤的 P&L。工廠端已改為 SYMBOL_SPEC 查表，故只在後台開放。
//  分類依據＝該商品「被驗證的 edge 在哪個週期」：
//     index_mr  → H1 均值回歸（book 實測 US500 Sharpe 0.80/PF 1.63）
//     trend_d1  → D1 趨勢跟隨（金 PF1.83 / 油 1.54 / 納指 1.60 / 天然氣 1.55 / BTC 2.06 / ETH 1.77）
export const FACTORY_EXTRA_SYMBOLS = [
  { code: 'US500Cash', label: '標普500 (US500Cash)',  short: '標普500', category: 'index_mr' },
  { code: 'GER40Cash', label: '德國DAX (GER40Cash)',  short: '德國DAX', category: 'index_mr' },
  { code: 'UK100Cash', label: '英國FTSE (UK100Cash)', short: '英國FTSE', category: 'index_mr' },
  // 2026-09-18 新增。⚠️ 回測已可跑（逐根換匯），但**實盤換匯未通**，
  //   liveConvertElite 擋著不准轉 LIVE → 產出的策略不會進許願池。
  { code: 'JP225Cash', label: '日經225 (JP225Cash)',   short: '日經225',  category: 'index_mr' },
  { code: 'US100Cash', label: '納斯達克 (US100Cash)', short: '納斯達克', category: 'trend_d1' },
  { code: 'OILCash',   label: 'WTI原油 (OILCash)',    short: 'WTI原油', category: 'trend_d1' },
  { code: 'NGASCash',  label: '天然氣 (NGASCash)',    short: '天然氣',  category: 'trend_d1' },
  { code: 'BTCUSD',    label: '比特幣 (BTCUSD)',      short: '比特幣',  category: 'trend_d1' },
  { code: 'ETHUSD',    label: '以太幣 (ETHUSD)',      short: '以太幣',  category: 'trend_d1' },
];

/** 後台（工廠/菁英庫/孵化池）用的完整商品池 */
export const FACTORY_SYMBOLS = [...SYMBOLS, ...FACTORY_EXTRA_SYMBOLS];
export const FACTORY_SYMBOL_CODES = FACTORY_SYMBOLS.map(s => s.code);

// code → 完整 label 對照 map（給 dropdown / Plan 詳情 / Revelation 卡顯示用）
//   未知 code 直接回原 code（防呆，避免 broker alias 沒對到時崩）
export const SYMBOL_LABEL_MAP = FACTORY_SYMBOLS.reduce((acc, s) => {
  acc[s.code] = s.label;
  return acc;
}, {});

// code → 短中文（去掉 (CODE) 後綴，給 inline 顯示用）
export const SYMBOL_SHORT_MAP = FACTORY_SYMBOLS.reduce((acc, s) => {
  acc[s.code] = s.short;
  return acc;
}, {});

// helper：拿 code 取中文 label，找不到回原 code
//   <span>{labelOfSymbol(elite.symbol)}</span>
//   → "黃金 (XAUUSD)" / 或 "USDCHF"（fallback）
export function labelOfSymbol(code) {
  if (!code) return '—';
  return SYMBOL_LABEL_MAP[code] || code;
}

// helper：拿 code 取短中文（適合放在卡片頂部、緊湊位置）
//   <span>{shortLabelOfSymbol(elite.symbol)}</span>
//   → "黃金" / 或 "USDCHF"（fallback）
export function shortLabelOfSymbol(code) {
  if (!code) return '—';
  return SYMBOL_SHORT_MAP[code] || code;
}

// 純 code 陣列（admin 後台某些地方只需要 list）
export const SYMBOL_CODES = SYMBOLS.map((s) => s.code);
